import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import { useAuth } from '../provider/authProvider';
import { ProtectedRoute } from './protectedRoutes';
import { AdminRoute } from './admin_routes';
import LoginPage from '../pages/Login';
import DashboardPage from '../pages/DashboardPage';
import RegisterPage from '../pages/Register';
import ManualOrderClose from '../pages/ManualOrderClose';
import LandingPage from '../pages/LandingPage';
import AdminMainPage from '../pages/Admin/admin_main_page';
import TemplateLibraryPage from '../Components/Admin/TemplateLibraryPage';
import AssignStrategyPage from '../pages/Admin/AssignStrategyPage';
import AlgoAnalyticsDashboard from '../pages/AlgoAnalyticsDashboard';
import AICoachPage from '../pages/AICoachPage';
import StrategyBuilderPage from '../pages/StrategyBuilderPage';

// Q AI Standalone Pages
import QAILandingPage from '../pages/QAI/QAILandingPage';
import QAISignupPage from '../pages/QAI/QAISignupPage';
import QAILoginPage from '../pages/QAI/QAILoginPage';
import QAICoachPage from '../pages/QAI/QAICoachPage';
import QAIMT5ReadyPage from '../pages/QAI/QAIMT5ReadyPage';
import QAITokensPage from '../pages/QAI/QAITokensPage';
import QBridgeSetupPage from '../pages/QAI/QBridgeSetupPage';

// Q AI Payment Pages (NOWPayments integration)
import PaymentSuccessPage from '../pages/QAI/PaymentSuccessPage';
import PaymentCancelPage from '../pages/QAI/PaymentCancelPage';
import PaymentHistoryPage from '../pages/QAI/PaymentHistoryPage';

// Q AI Context Provider
import { TokenBalanceProvider } from '../context/TokenBalanceContext';

// Q.AI Route Wrapper - provides TokenBalanceContext to all Q.AI pages
const QAIRoute = ({ children }) => (
    <TokenBalanceProvider>
        {children}
    </TokenBalanceProvider>
);

const AppRoutes = ()=>{
    const {token} = useAuth();

    return (
        <BrowserRouter>
            <Routes>
                {/* Q AI Standalone Routes (always accessible - must be first) */}
                {/* These routes share TokenBalanceContext for consistent token display */}
                <Route path="/q-ai" element={<QAIRoute><QAILandingPage /></QAIRoute>} />
                <Route path="/q-ai/signup" element={<QAIRoute><QAISignupPage /></QAIRoute>} />
                <Route path="/q-ai/login" element={<QAIRoute><QAILoginPage /></QAIRoute>} />
                <Route path="/q-ai/coach" element={<QAIRoute><QAICoachPage /></QAIRoute>} />
                <Route path="/q-ai/mt5-ready" element={<QAIRoute><QAIMT5ReadyPage /></QAIRoute>} />
                <Route path="/q-ai/tokens" element={<QAIRoute><QAITokensPage /></QAIRoute>} />

                {/* Q AI Payment Routes (NOWPayments redirect destinations) */}
                <Route path="/q-ai/payments/success" element={<QAIRoute><PaymentSuccessPage /></QAIRoute>} />
                <Route path="/q-ai/payments/cancel" element={<QAIRoute><PaymentCancelPage /></QAIRoute>} />
                <Route path="/q-ai/payments/history" element={<QAIRoute><PaymentHistoryPage /></QAIRoute>} />

                {/* QBridge Setup - Opened automatically after QBridge installation */}
                <Route path="/qbridge/setup" element={<QAIRoute><QBridgeSetupPage /></QAIRoute>} />

                {/* Public routes (unauthenticated) */}
                <Route path="/login" element={!token ? <LoginPage /> : <Navigate to="/dashboard" replace />} />
                <Route path="/register" element={!token ? <RegisterPage /> : <Navigate to="/dashboard" replace />} />

                {/* Root route */}
                <Route path="/" element={!token ? <LandingPage /> : <Navigate to="/dashboard" replace />} />

                {/* Protected routes (authenticated) */}
                <Route path="/dashboard" element={
                    <ProtectedRoute>
                        <DashboardPage />
                    </ProtectedRoute>
                } />
                <Route path="/logout" element={
                    <ProtectedRoute>
                        <></>
                    </ProtectedRoute>
                } />
                <Route path="/adminPanel" element={
                    <AdminRoute>
                        <AdminMainPage />
                    </AdminRoute>
                } />
                <Route path="/adminPanel/templates" element={
                    <AdminRoute>
                        <TemplateLibraryPage />
                    </AdminRoute>
                } />
                <Route path="/adminPanel/assign-strategy" element={
                    <AdminRoute>
                        <AssignStrategyPage />
                    </AdminRoute>
                } />
                <Route path="/manual-close" element={
                    <ProtectedRoute>
                        <ManualOrderClose />
                    </ProtectedRoute>
                } />
                <Route path="/algo-analytics" element={
                    <ProtectedRoute>
                        <AlgoAnalyticsDashboard />
                    </ProtectedRoute>
                } />
                <Route path="/ai-coach" element={
                    <ProtectedRoute>
                        <AICoachPage />
                    </ProtectedRoute>
                } />
                <Route path="/strategy-builder" element={
                    <ProtectedRoute>
                        <StrategyBuilderPage />
                    </ProtectedRoute>
                } />

                {/* Catch-all redirect */}
                <Route path="*" element={<Navigate to={token ? "/dashboard" : "/"} replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default AppRoutes;